export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="header"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/661464134e61d8a333a882c336229920.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-10 flex flex-col items-center">
        {/* Company name badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-400/40 bg-emerald-500/10 mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 flex items-center justify-center"></span>
          <span className="text-emerald-300 text-xs font-semibold tracking-widest uppercase">iOS Development Experts</span>
        </div>

        {/* Company Name */}
        <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6 tracking-tight">
          NEDZA DOO
        </h1>

        <p className="text-xl md:text-2xl text-white/70 font-light max-w-2xl leading-relaxed mb-4">
          Modern Applications for the iOS Platform
        </p>
        <p className="text-base md:text-lg text-white/50 max-w-xl leading-relaxed mb-12">
          Crafting premium mobile experiences — from powerful VPN security to intelligent device optimization.
        </p>

        {/* Scroll indicator */}
        <button
          onClick={() => handleScroll('#about')}
          className="flex flex-col items-center gap-2 text-white/40 hover:text-white/70 transition-colors cursor-pointer"
          aria-label="Scroll to about"
        >
          <span className="text-xs tracking-widest uppercase">Explore</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </button>
      </div>

      {/* Floating app cards */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
    </section>
  );
}
